import { useEffect } from 'react';
import { Options } from 'react-use-websocket';
import { useWebSocket } from 'react-use-websocket/dist/lib/use-websocket';
import {
  ChatMessageEvent,
  ChatMessageReactionEvent,
  ChatTypingEvent,
} from './resources/chat/types';

export const wssUrl = import.meta.env.VITE_SIMPLE_REST_URL || 'http://localhost:3000';

export type WssEvent = 'chat_typing';
export type WssTopic = 'chat_typing' | 'chat_message' | 'chat_message_reaction';

export interface TypingEvent {
  channelId: number;
  tenantCode: string;
}

export interface WssOptions extends Omit<Options, 'onMessage'> {
  subscribeTo: {
    chat_typing?: (json: ChatTypingEvent) => void;
    chat_message?: (json: ChatMessageEvent) => void;
    chat_message_reaction?: (json: ChatMessageReactionEvent) => void;
  };
}

export const useWssClient = (options: WssOptions) => {
  const { subscribeTo, onOpen, onClose, onError } = options;

  const accessToken = localStorage.getItem('accessToken');

  const { sendJsonMessage, lastJsonMessage, readyState } = useWebSocket(wssUrl, {
    queryParams: { token: accessToken },
    onOpen,
    onClose,
    onError,
  });

  useEffect(() => {
    if (lastJsonMessage) {
      try {
        const topic = lastJsonMessage.event as WssTopic;
        subscribeTo[topic]?.(lastJsonMessage);
      } catch (e) {
        console.error(e);
      }
    }
  }, [lastJsonMessage]);

  const sendEvent = (event: WssEvent, data: TypingEvent) => {
    sendJsonMessage({ event, data });
  };

  return { sendEvent, readyState };
};
